import { useEffect, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { googleLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const processAuth = useCallback(async () => {
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/auth', { replace: true });
      return;
    }

    const sessionId = match[1];
    const result = await googleLogin(sessionId);
    // Clear hash
    window.history.replaceState(null, '', window.location.pathname);
    if (result.success) {
      if (result.data?.onboarding_complete) {
        navigate('/dashboard', { replace: true, state: { user: result.data } });
      } else {
        navigate('/onboarding', { replace: true, state: { user: result.data } });
      }
    } else {
      navigate('/auth', { replace: true });
    }
  }, [googleLogin, navigate, location.hash]);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    processAuth();
  }, [processAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 size={32} className="animate-spin mx-auto mb-4" style={{ color: '#00D4FF' }} />
        <p className="text-sm text-zinc-500">Completing Google sign-in...</p>
      </div>
    </div>
  );
}
